<!--
 * @Author: zhangzhian
 * @Date: 2023-04-25 17:42:55
 * @LastEditors: Gyan
 * @LastEditTime: 2024-10-11 13:55:37
 * @FilePath: \dhr_frontend\src\components\LinTextarea\index.vue
 * @Description: 重构ant-design的TextArea组件(已做全局引入)
 * @ImportRoute: import LinTextarea from '@/components/LinTextarea/index.vue';
-->

<template>
  <div class="custom-text-area" :class="{'custom-text-area--rows1': rows === 1}">
    <a-textarea
      v-if="rows !== 1"
      v-bind="$attrs"
      v-on="$listeners"
      :value="value"
      :rows="rows"
      :maxLength="maxLength"
      placeholder="请输入"
    />

    <a-input
      v-else
      v-bind="$attrs"
      v-on="$listeners"
      :value="value"
      :maxLength="maxLength"
    />

    <div class="custom-text-area__count">
      {{ (value || "").length }}/{{ maxLength || maxNum }}
    </div>
  </div>
</template>

<script>
export default {
  name: "LinTextarea",

  props: {
    value: {
      type: String,
    },
    maxNum: {
      type: [String, Number],
    },
    maxLength: {
      type: [String, Number],
    },
    rows: {
      type: [String, Number],
    },
  },

  model: {
    prop: "value",
    event: "change.value",
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.custom-text-area {
  position: relative;
  &__count {
    font-size: 12px;
    line-height: 12px;
    display: block;
    position: absolute;
    right: 12px;
    bottom: 6px;
    background-color: #fff;
  }

  &--rows1 {
    .custom-text-area__count {
      bottom: 50%;
      transform: translateY(55%);
    }

    .ant-input {
      padding-right: 60px;
    }
  }

  textarea {
    padding-bottom: 10px;
  }
}
</style>
